import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { FlexBox, Stack } from '@ardoq/layout';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoNumericFieldsDoqProps = { doqType: DoqType; i18nLocale: I18nLocale };

const NoNumericFieldsDoqBase = ({
  doqType,
  i18nLocale,
}: NoNumericFieldsDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noNumericFields.title',
          'No number fields to show'
        )}
        message={
          <Stack gap="xlarge">
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noNumericFields.message1',
                "This workspace doesn't have any number fields."
              )}
            </FlexBox>
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noNumericFields.message2',
                'To use this view, add a number field to your components.'
              )}
            </FlexBox>
          </Stack>
        }
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoNumericFieldsDoq = connect(
  NoNumericFieldsDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
